var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-apex-charts',{attrs:{"height":"400","type":_vm.chart.type,"options":_vm.chart.options,"series":_vm.chart.series}})}
var staticRenderFns = []

export { render, staticRenderFns }